import { identity } from 'ramda';

export const fillArray = (arr, arrLen) => {
    let res = arr;

    while (res.length < arrLen) {
        res = [...res, ...arr.slice(0, arrLen - res.length)];
    }

    return res;
};

export const getRandomGames = (games = [], maxLength = 20) => {
    const gamesLen = games.length;
    const maxLen = gamesLen < maxLength ? gamesLen : maxLength;
    let result = [];

    while (result.length < maxLen) {
        const randIndex = Math.floor(Math.random() * gamesLen);
        const game = games[randIndex];

        if (!result.includes(game)) {
            result = [...result, game];
        }
    }

    return fillArray(result, maxLength);
};

export const getCurrentWheelFace = ({ wheelRotationAngle, faceTiltAngle, facesLength }) =>
    Math.round(Math.abs(wheelRotationAngle) / faceTiltAngle) % facesLength;

const animate = ({ timing, draw, duration, onProgress, onAnimationEnd }) => {
    const start = performance.now();
    const anim = (time) => {
        let timeFraction = (time - start) / duration;

        if (timeFraction > 1) {
            timeFraction = 1;
        }

        const progress = timing(timeFraction);
        draw(progress);

        if (timeFraction < 1) {
            onProgress(requestAnimationFrame(anim));
        } else {
            onAnimationEnd();
        }
    };

    onProgress(requestAnimationFrame(anim));
};

const easeInOutSmoother = (t) => {
    const ts = t * t;
    const tc = ts * t;

    return 6 * tc * ts - 15 * ts * ts + 10 * tc;
};

export default ({
    duration = 3000,
    timing = easeInOutSmoother,
    draw = identity,
    onProgress = identity,
    onAnimationEnd = identity
}) => animate({ duration, timing, draw, onProgress, onAnimationEnd });
